import { Paths } from "../routes/paths";
import axiosInstance from "../services/axios";
import { LOCAL_STORAGE_KEYS } from "../constants/api";
import { setFeatures } from "../redux/features";
import { AppDispatch } from "../redux/store";

/**
 * Save token and setup authorization header.
 * Also marks the login as manual to prevent auto-initialization from Auth0.
 */
export const setSession = (token: string) => {
  if (token) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, token);
    localStorage.setItem(LOCAL_STORAGE_KEYS.MANUAL_LOGIN, "true");
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    clearSession();
  }
};

/**
 * Get the current token from localStorage.
 */
export const getSession = (): string | null => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
};

/**
 * Remove token, auth header, and manual login flag.
 * Redirect to login page.
 */
export const removeSession = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
  delete axiosInstance.defaults.headers.common["Authorization"];
  window.location.href = `/${Paths.login}`; // לא ל־auth/home!
};

/**
 * Clear local session data (without redirection).
 */
export const clearSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("manual-login-in-progress");
  delete axiosInstance.defaults.headers.common["Authorization"];
};

/**
 * Decode the payload of a JWT.
 */
export const jwtDecode = (token: string): any => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

/**
 * Validate if the JWT is still valid.
 */
export const isValidToken = (token: string): boolean => {
  if (!token) return false;
  const decoded = jwtDecode(token);
  if (!decoded || !decoded.exp) return false;
  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp > currentTime;
};

export async function loadFeatures(dispatch: AppDispatch) {
  console.log("Loading features...");
  try {
    const response = await axiosInstance.get("/Login/features", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("Loaded features:", response.data);

    localStorage.setItem("features", JSON.stringify(response.data));
        dispatch(setFeatures(response.data));
  } catch (err) {
    console.error("Failed to load features:", err);
    localStorage.setItem("features", "[]");
  }
}
